// extracted by mini-css-extract-plugin
export default {"cgv":"CGV_cgv__gsmCl","title":"CGV_title__Xy2z6"};